import { TeamUserRole } from "@shaarp/common";

export enum TeamUserRolesEnum {
  ADMIN = "admin",
  MANAGER = "manager",
  MEMBER = "member",
  BILLING = "billing",
  ADVISOR = "advisor",
}

const ROLE_LABEL_KEYS: Record<TeamUserRole, string> = {
  [TeamUserRolesEnum.ADMIN]: "components.dataTableUsers.roles.administrator",
  [TeamUserRolesEnum.MANAGER]: "components.dataTableUsers.roles.manager",
  [TeamUserRolesEnum.MEMBER]: "components.dataTableUsers.roles.member",
  [TeamUserRolesEnum.BILLING]: "components.dataTableUsers.roles.billing",
  [TeamUserRolesEnum.ADVISOR]: "components.dataTableUsers.roles.advisor",
};

export function getTeamUserRoleLabel(
  role: TeamUserRole,
  t: (key: string) => string,
): string {
  const key = ROLE_LABEL_KEYS[role];
  return key ? t(key) : role;
}
